// removed by extract-text-webpack-plugin
module.exports = {"container":"Preferences__container__32xVb","contentBox":"Preferences__contentBox__ogYW2","tabButtons":"Preferences__tabButtons__yvb8B","tabContent":"Preferences__tabContent__9feed","tabBtn":"Preferences__tabBtn__dVzVQ","activeBtn":"Preferences__activeBtn__3GwKT","row":"Preferences__row__2ojce","leftCol":"Preferences__leftCol__1HY75","rightCol":"Preferences__rightCol__28-t_","clearFix":"Preferences__clearFix__PSzyH","txtBox":"Preferences__txtBox__3y3m6","btnSave":"Preferences__btnSave__18h-A","fullWidth":"Preferences__fullWidth__3XiR4"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/Preferences/Preferences.css
// module id = 584
// module chunks = 0